var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import login from '../../requests/authentication/login';
import Session from '../../services/Session';
import History from '../../services/History';
import GetCurrentUserCommand from '../users/GetCurrentUserCommand';
import Signals from '../../signals/Signals';
import Routes from '../../routes/RoutesConfig';
import LogoutCommand from './LogoutCommand';
/**
 *
 */
var LoginCommand = /** @class */ (function (_super) {
    __extends(LoginCommand, _super);
    function LoginCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param email
     * @param password
     * @param intl
     * @return {Promise<any | never>}
     */
    LoginCommand.prototype.execute = function (email, password, intl) {
        this.email = email;
        this.intl = intl;
        //
        var promise = login(email, password);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    LoginCommand.prototype.then = function (response) {
        var _this = this;
        Session.setJWT(response.jwt);
        // Get user details
        var command = new GetCurrentUserCommand();
        command.execute().then(function () {
            var user = Session.user;
            if (!user.isValidated) {
                // Logout
                var logoutCommand = new LogoutCommand();
                logoutCommand.execute();
                // Display message
                Signals.ShowAlertModal.dispatch(_this.intl.formatMessage({ id: 'page.login.alert.accountnotvalidated.title' }), _this.intl.formatMessage({ id: 'page.login.alert.accountnotvalidated.body' }, Object(_this)));
            }
            else {
                var deeplink = Session.getDeeplink(true);
                if (deeplink) {
                    History.push(deeplink);
                }
                else {
                    History.replace(Routes.ASSETS.path);
                }
                Signals.LoggedIn.dispatch();
            }
        });
    };
    LoginCommand.prototype.catch = function (error) {
        //Session.setJWT(null);
    };
    return LoginCommand;
}(Command));
export default LoginCommand;
